import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value", "button"]

  connect() {
    this.revealed = false
  }

  toggle() {
    this.revealed = !this.revealed
    this.valueTarget.classList.toggle("blur-sm", !this.revealed)
    this.buttonTarget.textContent = this.revealed ? "Hide" : "Reveal"
  }
}
